<span
  [ngClass]="{
    code: model?.style?.code,
    bold: model?.style?.bold,
    italic: model?.style?.italic,
    strike: model?.style?.strike,
    padding: model?.style?.backgroundColor || model?.style?.code,
    'new-line': startNewLine
  }"
  [style.background-color]="theme === 'light' ? model?.style?.backgroundColor?.lightTheme : model?.style?.backgroundColor?.darkTheme"
  [style.color]="theme === 'light' ? model?.style?.textColor?.lightTheme : model?.style?.textColor?.darkTheme"
  [innerHtml]="model.text | richTextFormatted | highlight: (model?.style?.backgroundColor ? [] : highlights)"
></span>
